import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import overlayImage from '../assets/croppedscroll.png';
import { getCSRFToken } from '../utils/csrf';
import '../pages/journeybuttons.css';
import '../pages/campfirepage.css';
import './QuizPage.css'
import api from '../api.js'



function QuizPage({
  title,
  subTopic,
  backgroundImage,
  returnPath,
}) {
  const navigate = useNavigate();
  const [question, setQuestion] = useState(null);
  const [shuffledAnswers, setShuffledAnswers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(null);
  const [showCongrats, setShowCongrats] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [lastResult, setLastResult] = useState(null);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [timeLeft, setTimeLeft] = useState(10);
  const [outOfTime, setOutOfTime] = useState(false);
  const formattedTimer = `${String(Math.floor(timeLeft / 60)).padStart(2, '0')}:${String(timeLeft % 60).padStart(2, '0')}`;
  const token = localStorage.getItem('access_token');

  useEffect(() => {
    fetchQuestion();
    fetchProgress();
  }, []);

  useEffect(() => {
    if (!question || selectedAnswer || outOfTime) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          setOutOfTime(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [question, selectedAnswer, outOfTime]);

  const shuffleArray = arr => [...arr].sort(() => Math.random() - 0.5);

  const fetchQuestion = async () => {
    if (outOfTime) return;
    setLoading(true);
    try {
      const res = await api.get('/api/questions/', { params: { sub_topic: subTopic },          withCredentials: false,                          // <-- no cookies
          headers: { Authorization: `Bearer ${token}` },  });
      const q = res.data;
      const answers = [q.answer, q.alternative_1, q.alternative_2, q.alternative_3];
      setQuestion(q);
      setShuffledAnswers(shuffleArray(answers));
    } catch (err) {
      if (err.response?.status === 204) {
        setCompleted(true);
      } else {
        console.error(err);
        alert('Failed to load a new question.');
      }
    }
    setLoading(false);
  };

  const fetchProgress = async () => {
    try {
      const res = await api.get(`${process.env.REACT_APP_API_URL}/api/progress/`, {
        params: { sub_topic: subTopic },
      });
      setProgress(res.data);
      setShowCongrats(res.data.percent_correct === 100);
    } catch (err) {
      console.error('Progress fetch error:', err);
    }
  };

  const handleAnswerClick = async answer => {
    if (!question || selectedAnswer) return;
    setSelectedAnswer(answer);
    

    try {
      const response = await api.post(`${process.env.REACT_APP_API_URL}/api/submit-answer/`,
        { question_id: question.id, selected_answer: answer },
      );

      const correct = response.data.correct;
      setLastResult(correct ? 'correct' : 'wrong');
      setTimeLeft(10);
      await fetchProgress();

      setTimeout(() => {
        setSelectedAnswer(null);
        setLastResult(null);
        fetchQuestion();
      }, 1000);
    } catch (err) {
      console.error('Submission error:', err);
    }
  };

  const handleRestart = async () => {
    try {
      await api.post(`${process.env.REACT_APP_API_URL}/api/reset/`,
        { sub_topic: subTopic },
      );
      setCompleted(false);
      fetchQuestion();
      fetchProgress();
    } catch (err) {
      console.error('Reset failed', err);
    }
  };

  return (
    <div className="quiz-page-wrapper">
      <div className="medieval-text" style={{ height: '5vh', backgroundColor: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem' }}>
      </div>

    {/* Quiz background ART */}
  <div className="quiz-background-wrapper">
  <img src={backgroundImage} alt="Background" className="topic-background-image" />







        <div className="back-button-wrapper-bottom">
          <button
            className="journey-button"
            onClick={() => navigate(returnPath)}
          >
            ⬅ Back
          </button>
        </div>




        {/* Floating scrolls */}
        <img src={overlayImage} className="bobbing2 floating-scroll" alt="" />
        <img src={overlayImage} alt="Top Scroll" className="quiz-scroll top-right-scroll" />
        <img src={overlayImage} alt="Bottom Scroll" className="quiz-scroll bottom-right-scroll" />



        {/* Quiz Content */}
<div className="quiz-content-container">

          {showCongrats && (
            <div className="medieval-text" style={{ border: '2px solid gold', padding: '1rem' }}>
              🎉 You've mastered this topic! 🎉
              <br />
              <button className="journey-button" onClick={handleRestart}>🔁 Restart</button>
            </div>
          )}
          {outOfTime ? (
            <>
              <h2 className="medieval-text">⏳ Time’s Up!</h2>
            </>
          ) : loading ? (
            <p>Loading...</p>
          ) : (
            <>
              <h2 className="medieval-text">{question.question_text}</h2>
              {shuffledAnswers.map((ans, idx) => {
                let className = "journey-button";
                if (selectedAnswer) {
                  if (ans === selectedAnswer) className += lastResult === 'correct' ? ' correct-answer' : ' wrong-answer';
                  if (ans === question.answer && lastResult === 'wrong') className += ' correct-answer';
                }
                return (
                  <button key={idx} className={`quiz-answer-button ${className}`} onClick={() => handleAnswerClick(ans)} disabled={!!selectedAnswer}>
                    {ans}
                  </button>
                );
              })}
            </>
          )}
        </div>

        {/* Progress + Timer */}
        <div className="quiz-progress">
          <span className="medieval-text">{progress ? `${progress.percent_correct}%` : '...'}</span><br />
          <span className="medieval-text" style={{ fontSize: '0.9em', opacity: 0.8 }}>Completed</span>
        </div>

        <div className="quiz-timer">
          <span className="medieval-text">⏳ ({formattedTimer})</span>
        </div>











      </div>

      {/* Bottom Bar */}
      <div style={{ height: '7vh', backgroundColor: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem' }}>
        
      </div>
    </div>
  );
}

export default QuizPage;
